import Root from '@/components/BasicLayout.vue'

// 发布相关路由-需登录后才能访问
export default [
  {
    path: '/releaseIndex',
    name: 'releaseIndex',
    meta: {
      alias: '发布首页',
      exemption: true
    },
    component: () => import(/* webpackChunkName: "release" */ '@/views/release/index.vue')
  },
  {
    path: '/interview',
    name: 'interview',
    meta: {
      alias: '项目访谈',
      exemption: true
    },
    component: () => import(/* webpackChunkName: "interview" */ '@/views/interview/index.vue')
  },
  {
    path: '/release',
    name: 'release',
    redirect: '',
    meta: {
      alias: '发布信息',
      exemption: true
    },
    children: [
      {
        path: '/purchaser/create',
        name: 'purchaserCreate',
        meta: {
          alias: '并购买方/投资方需求',
          exemption: true,
          openKey: '/release'
        },
        component: () => import(/* webpackChunkName: "release" */ '@/views/purchaser/create.vue')
      },
      {
        path: '/subjectMatter/create',
        name: 'subjectMatterCreate',
        meta: {
          alias: '并购标的/融资项目',
          exemption: true,
          openKey: '/release'
        },
        component: () =>
          import(/* webpackChunkName: "release" */ '@/views/subjectMatter/create.vue')
      },
      {
        path: '/talentHeadhunting/create',
        name: 'talentHeadhuntingCreate',
        meta: {
          alias: '人才猎头信息',
          exemption: true,
          openKey: '/release'
        },
        component: () =>
          import(/* webpackChunkName: "release" */ '@/views/talentHeadhunting/create.vue')
      },
      {
        path: '/finance/create',
        name: 'financeCreate',
        meta: {
          alias: '厂房/写字楼/园区-出售/招租',
          exemption: true,
          openKey: '/release'
        },
        component: () => import(/* webpackChunkName: "release" */ '@/views/finance/create.vue')
      },
      {
        path: '/lease/create',
        name: 'leaseCreate',
        meta: {
          alias: '厂房/写字楼/园区-购买/租赁',
          exemption: true,
          openKey: '/release'
        },
        component: () => import(/* webpackChunkName: "release" */ '@/views/lease/create.vue')
      },
      {
        path: '/supplier/create',
        name: 'supplierCreate',
        meta: {
          alias: '寻找客户/供应商',
          exemption: true,
          openKey: '/release'
        },
        component: () => import(/* webpackChunkName: "release" */ '@/views/supplier/create.vue')
      },
      {
        path: '/intermediary/create',
        name: 'intermediaryCreate',
        meta: {
          alias: '雇用专业中介机构',
          exemption: true,
          openKey: '/release'
        },
        component: () => import(/* webpackChunkName: "release" */ '@/views/intermediary/create.vue')
      },
      {
        path: '/thinkTankExpert/create',
        name: 'thinkTankExpertCreate',
        meta: {
          alias: '寻找智库专家',
          exemption: true,
          openKey: '/release'
        },
        component: () =>
          import(/* webpackChunkName: "release" */ '@/views/thinkTankExpert/create.vue')
      },
      {
        path: '/investor/create',
        name: 'investorCreate',
        meta: {
          alias: '寻找资方',
          exemption: true,
          openKey: '/release'
        },
        component: () => import(/* webpackChunkName: "release" */ '@/views/investor/create.vue')
      }
    ]
  },
  {
    path: '/management',
    name: 'management',
    redirect: '',
    meta: {
      alias: '管理项目/信息',
      exemption: true
    },
    children: [
      {
        path: '/purchaser/list',
        name: 'purchaserList',
        meta: {
          alias: '并购买方/投资方需求',
          exemption: true,
          openKey: '/management'
        },
        component: () => import(/* webpackChunkName: "management" */ '@/views/purchaser/list.vue')
      },
      {
        path: '/purchaser/edit',
        name: 'purchaserEdit',
        meta: {
          alias: '并购买方/投资方需求',
          exemption: true,
          openKey: '/management',
          activeMenu: '/purchaser/list'
        },
        component: () => import(/* webpackChunkName: "management" */ '@/views/purchaser/edit.vue')
      },
      {
        path: '/subjectMatter/list',
        name: 'subjectMatterList',
        meta: {
          alias: '并购标的/融资项目',
          exemption: true,
          openKey: '/management'
        },
        component: () =>
          import(/* webpackChunkName: "management" */ '@/views/subjectMatter/list.vue')
      },
      {
        path: '/subjectMatter/edit',
        name: 'subjectMatterEdit',
        meta: {
          alias: '并购买方/投资方需求',
          exemption: true,
          openKey: '/management',
          activeMenu: '/subjectMatter/list'
        },
        component: () =>
          import(/* webpackChunkName: "management" */ '@/views/subjectMatter/edit.vue')
      },
      {
        path: '/talentHeadhunting/list',
        name: 'talentHeadhuntingList',
        meta: {
          alias: '人才猎头信息',
          exemption: true,
          openKey: '/management',
          activeMenu: '/talentHeadhunting/list'
        },
        component: () =>
          import(/* webpackChunkName: "management" */ '@/views/talentHeadhunting/list.vue')
      },
      {
        path: '/talentHeadhunting/edit',
        name: 'talentHeadhuntingEdit',
        meta: {
          alias: '人才猎头信息',
          exemption: true,
          openKey: '/management',
          activeMenu: '/talentHeadhunting/list'
        },
        component: () =>
          import(/* webpackChunkName: "management" */ '@/views/talentHeadhunting/edit.vue')
      },
      {
        path: '/finance/list',
        name: 'financeList',
        meta: {
          alias: '厂房/写字楼/园区-出售/招租',
          exemption: true,
          openKey: '/management',
          activeMenu: '/finance/list'
        },
        component: () => import(/* webpackChunkName: "management" */ '@/views/finance/list.vue')
      },
      {
        path: '/finance/edit',
        name: 'financeEdit',
        meta: {
          alias: '厂房/写字楼/园区-出售/招租',
          exemption: true,
          openKey: '/management',
          activeMenu: '/finance/list'
        },
        component: () => import(/* webpackChunkName: "management" */ '@/views/finance/edit.vue')
      },
      {
        path: '/lease/list',
        name: 'leaseList',
        meta: {
          alias: '厂房/写字楼/园区-购买/租赁',
          exemption: true,
          openKey: '/management',
          activeMenu: '/lease/list'
        },
        component: () => import(/* webpackChunkName: "management" */ '@/views/lease/list.vue')
      },
      {
        path: '/lease/edit',
        name: 'leaseEdit',
        meta: {
          alias: '厂房/写字楼/园区-购买/租赁',
          exemption: true,
          openKey: '/management',
          activeMenu: '/lease/list'
        },
        component: () => import(/* webpackChunkName: "management" */ '@/views/lease/edit.vue')
      },
      {
        path: '/supplier/list',
        name: 'supplierList',
        meta: {
          alias: '寻找客户/供应商',
          exemption: true,
          openKey: '/management',
          activeMenu: '/supplier/list'
        },
        component: () => import(/* webpackChunkName: "management" */ '@/views/supplier/list.vue')
      },
      {
        path: '/supplier/edit',
        name: 'supplierEdit',
        meta: {
          alias: '寻找客户/供应商',
          exemption: true,
          openKey: '/management',
          activeMenu: '/supplier/list'
        },
        component: () => import(/* webpackChunkName: "management" */ '@/views/supplier/edit.vue')
      },
      {
        path: '/intermediary/list',
        name: 'intermediaryList',
        meta: {
          alias: '雇用专业中介机构',
          exemption: true,
          openKey: '/management',
          activeMenu: '/intermediary/list'
        },
        component: () =>
          import(/* webpackChunkName: "management" */ '@/views/intermediary/list.vue')
      },
      {
        path: '/intermediary/edit',
        name: 'intermediaryEdit',
        meta: {
          alias: '雇用专业中介机构',
          exemption: true,
          openKey: '/management',
          activeMenu: '/intermediary/list'
        },
        component: () =>
          import(/* webpackChunkName: "management" */ '@/views/intermediary/edit.vue')
      },
      {
        path: '/thinkTankExpert/list',
        name: 'thinkTankExpertList',
        meta: {
          alias: '寻找智库专家',
          exemption: true,
          openKey: '/management',
          activeMenu: '/thinkTankExpert/list'
        },
        component: () =>
          import(/* webpackChunkName: "management" */ '@/views/thinkTankExpert/list.vue')
      },
      {
        path: '/thinkTankExpert/edit',
        name: 'thinkTankExpertEdit',
        meta: {
          alias: '寻找智库专家',
          exemption: true,
          openKey: '/management',
          activeMenu: '/thinkTankExpert/list'
        },
        component: () =>
          import(/* webpackChunkName: "management" */ '@/views/thinkTankExpert/edit.vue')
      },
      {
        path: '/investor/list',
        name: 'investorList',
        meta: {
          alias: '寻找资方',
          exemption: true,
          openKey: '/management',
          activeMenu: '/investor/list'
        },
        component: () => import(/* webpackChunkName: "management" */ '@/views/investor/list.vue')
      },
      {
        path: '/investor/edit',
        name: 'investorEdit',
        meta: {
          alias: '寻找资方',
          exemption: true,
          openKey: '/management',
          activeMenu: '/investor/list'
        },
        component: () => import(/* webpackChunkName: "management" */ '@/views/investor/edit.vue')
      }
    ]
  }
]
